/**
 * verify 模块提供常用的类型验证相关接口
 * @module verify
 */

export const isString = val => typeof val === 'string';
export const isObject = val => val !== null && typeof val === 'object';
export const isArray = Array.isArray;
export const isFunction = val => typeof val === 'function';
export const isPromise = val => isObject(val) && isFunction(val.then); // tips：根据 ECMAScript 规范，带有 then 方法的对象判定为 promise
